<template>
  <div>
    <h1>Tareas</h1>
  </div>
</template>

<script>
export default {
  name: "TaskList"
};
</script>

<style></style>
